(ns frontend.view.reports.custom.alj-2.total-deals-per-business-unit-table
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.reports.custom.alj :as alj]
   [frontend.view.reports.custom.alj-2.alj-components :as alj-components]
   [frontend.view.reports.custom.alj-2.utils :as alj-utils]))

(defn count-by-status
  [oppos status]
  (->> oppos
       (cu/filter-by :oppo/status status)
       (count)))

(defn row-data
  [approved-id oppos label]
  {:label           label
   :total-deals     (count oppos)
   :active-deals    (count-by-status oppos :oppo.status/ok)
   :portfolio-deals (count-by-status oppos :oppo.status/portfolio)
   :passed-deals    (count-by-status oppos :oppo.status/passed)
   :on-hold-deals   (count-by-status oppos :oppo.status/on-hold)
   :approved-deals  (->> oppos
                         (cu/filter-by :oppo/CIC-recommendation approved-id)
                         (count))})

(defn data-cell
  [cell-data]
  (let [no-data? (= 0 cell-data)]
    [:td
     {:class-name (fu/cs "number-cell"
                         (when no-data?
                           "empty-cell"))}
     (if no-data?
       "-"
       (str cell-data))]))

(defn table-row
  [row-class-name
   {:keys [label total-deals active-deals portfolio-deals on-hold-deals passed-deals
           approved-deals]}]
  [:tr
   {:class-name (fu/cs row-class-name)}
   [:td label]
   [:td.highlight-cell.number-cell total-deals]
   [data-cell active-deals]
   [data-cell portfolio-deals]
   [data-cell on-hold-deals]
   [data-cell passed-deals]
   ;; hide, remove once customer has approved
   #_[data-cell approved-deals]])

(defn report
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{} [:entity.type/oppo]]
                          [:date-cic #{:entity.type/oppo} [:entity.type/oppo]]
                          [:date-portfolio #{} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [deals (->> (alj/all-deals)
                       (cu/remove-by :oppo/status :oppo.status/on-hold)
                       (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/date-CIC-presentation @date-state-atom :date-cic :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/moved-to-portfolio-on @date-state-atom :date-portfolio :entity.type/oppo))

            approved-id (->> (session/named-values :oppo/CIC-recommendation)
                             (remove :common/disabled?)
                             (cu/filter-by :named-value/value "Approved")
                             (first)
                             :db/id)

            active-business-units (session/non-archived-named-values :oppo/group-business-units
                                                                     (alj/alj-report-pipeline-id))
            active-business-unit-ids (->> active-business-units
                                          (map :db/id)
                                          (set))
            oppos-by-business-unit (->> deals
                                        (mapcat (fn [oppo]
                                                  (->> oppo
                                                       :oppo/group-business-units
                                                       (map (fn [bu-id]
                                                              [bu-id oppo])))))
                                        (group-by first)
                                        (map (fn [[bu-id bu-id-oppos]]
                                               [bu-id
                                                (->> bu-id-oppos
                                                     (map second)
                                                     (doall))]))
                                        (into {}))
            business-units-deals-data
            (->> active-business-units
                 (map (fn [nv]
                        (let [bu-oppos (get oppos-by-business-unit (:db/id nv))]
                          (row-data approved-id bu-oppos (entity/display-string nv)))))
                 (sort-by :total-deals)
                 (reverse))
            oppos-without-active-bu (->> deals
                                         (remove (fn [oppo]
                                                   (some active-business-unit-ids
                                                         (:oppo/group-business-units oppo)))))
            no-active-bu-data (when (seq oppos-without-active-bu)
                                (row-data approved-id
                                          oppos-without-active-bu
                                          (loc/tr :oppos-without-active-group-business-unit)))
            duplicate-bus (->> deals
                               (filter (fn [oppo]
                                         (> (count (:oppo/group-business-units oppo)) 1))))
            duplicate-bus-data
            (when (seq duplicate-bus)
              (row-data approved-id duplicate-bus (loc/tr :oppos-with-duplicate-business-units)))]
        [alj-components/alj-card
         {:view-name       (loc/tr :total-deals-per-SBU-and-status)
          :report-data     business-units-deals-data
          :date-state-atom date-state-atom
          :view            [:table.alj-report.zap-simple-table
                            [:thead
                             [:tr
                              [:th "SBU"]
                              [:th (loc/tr :total-number-of-deals)]
                              [:th (loc/tr :total-active-deals)]
                              [:th (loc/tr :total-portfolio-deals)]
                              [:th (loc/tr :total-on-hold-deals)]
                              [:th (loc/tr :total-passed-deals)]
                              ;; hide, remove once customer has approved
                              #_[:th (loc/tr :total-approved-deals)]]]
                            [:tbody
                             (->> business-units-deals-data
                                  (map-indexed (fn [idx row-data]
                                                 ^{:key (str "alj-2-total-deals-per-business-units-" idx)}
                                                 [table-row "alj-data-row" row-data]))
                                  (doall))]
                            [:tfoot
                             [table-row "alj-totals-row" (row-data approved-id deals (loc/tr :grand-total))]
                             (when no-active-bu-data
                               [table-row "alj-error-row" no-active-bu-data])
                             (when duplicate-bus-data
                               [table-row "alj-duplicate-row" duplicate-bus-data])]]}]))))
